import { render, staticRenderFns } from "./TrueFalse_bank.vue?vue&type=template&id=5c965f1c"
import script from "./TrueFalse_bank.vue?vue&type=script&lang=js"
export * from "./TrueFalse_bank.vue?vue&type=script&lang=js"
import style0 from "./TrueFalse_bank.vue?vue&type=style&index=0&id=5c965f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports